import { StoreConfig, Query, Store } from '@datorama/akita';
import produce from 'immer';
import { Statistics, StatisticsPeriod } from '../types';

export interface StatisticsState {
  period: StatisticsPeriod;
  statistics: Statistics | null;
  loading: boolean;
}

const createInitialState = (): StatisticsState => ({
  period: 'lastDay',
  statistics: null,
  loading: true,
});

@StoreConfig({ name: 'statisticsStore', producerFn: produce })
export class StatisticsStore extends Store<StatisticsState> {
  constructor() {
    super(createInitialState());
  }
}

export class StatisticsQuery extends Query<StatisticsState> {
  readonly period$ = this.select((state) => state.period);
  readonly statistics$ = this.select((state) => state.statistics);
  readonly loading$ = this.selectLoading();

  constructor(protected store: StatisticsStore) {
    super(store);
  }
}

export const statisticsStore = new StatisticsStore();
export const statisticsQuery = new StatisticsQuery(statisticsStore);
